import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const FormLabel = React.forwardRef(({ className, required = false, ...props }, ref) => {
    return (_jsxs("label", { ref: ref, className: cn('text-sm font-medium text-gray-700', className), ...props, children: [props.children, required && _jsx("span", { className: "text-red-500 ml-1", children: "*" })] }));
});
FormLabel.displayName = 'FormLabel';
export { FormLabel };
